import type { NavSection } from "@/constants/appSidebar";

// 현재 경로가 해당 URL(하위 경로 포함)과 일치하는지 확인
export const isPathActive = (pathname: string, url: string) =>
  pathname === url || pathname.startsWith(`${url}/`);

// 묶음 안의 항목 중 현재 경로와 일치하는 것이 하나라도 있는지 확인
// (하위 메뉴 url 은 모두 부모 항목 url 아래에 있으므로 부모만 보면 된다)
export const isSectionActive = (section: NavSection, pathname: string) =>
  section.items.some((item) => isPathActive(pathname, item.url));
